var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"gl-flex gl-py-2"},[_c('div',{staticClass:"gl-border-l gl-ml-2 gl-pl-3"})])
}]

export { render, staticRenderFns }